import { SectionDetails } from '@/app/types/marketing/SectionDetails';
import GeneratorLandingPage from '@/components/generator-landing-page/GeneratorLandingPage';
import { AcademicCapIcon, CameraIcon } from '@heroicons/react/20/solid';
import { LightBulbIcon, SparklesIcon } from '@heroicons/react/24/outline';
import { ClipboardDocumentListIcon } from '@heroicons/react/24/solid';
import { TableCellsIcon } from '@heroicons/react/24/solid';
import overviewImage from '@/public/image-landing-image.png';

const imageSection: SectionDetails = {
  miniText: 'Optimized studying',
  title: 'Flashcards in seconds',
  image: overviewImage,
  description:
    'Limbiks leverages the latest AI technology to create comprehensive flashcards that are easy to consume and focus on the content you need to know.',
  features: [
    {
      name: 'Snap a picture.',
      description:
        'Not only will Limbiks generate from screenshots and images from your study materials, but you can also take pictures of notes and more.',
      icon: CameraIcon
    },
    {
      name: 'Smart Image Analysis.',
      description:
        'Limbiks uses advanced AI technology to gain a full understanding of your image and output the flashcards best for you.',
      icon: SparklesIcon
    },
    {
      name: 'Selectable flashcard types.',
      description:
        'Generate question and answer, fill in the blank, and image occlusion flashcards. Choose the type that works best for you.',
      icon: TableCellsIcon
    }
  ]
};

const featureSection: SectionDetails = {
  miniText: 'Optimized learning',
  title: 'Advanced AI study tools',
  description:
    'Limbiks offers novel AI study tools so you can master your flashcards.  Our tools are custom built with all of the latest AI advancements to ensure you are getting the best possible study experience.  ',
  features: [
    {
      name: 'Hints and Explanations',
      description:
        'Limbiks has hints and explanations anytime you need a little extra help.  Use hints if you just need a little help and use explanations for a complete understanding',
      icon: LightBulbIcon
    },
    {
      name: 'Practice Tests',
      description:
        'Take a full practice exam from any of your flashcard decks.  For a comprehensive exam, you can even combine multiple decks. See your results with a full score report including study tips.',
      icon: AcademicCapIcon
    },
    {
      name: 'AI Study Guides',
      description:
        'Generate study guides with every upload.  Limbiks uses AI to analyze your content and build a focused study guide of everything you need to know. All study guides can be downloaded and printed.',
      icon: ClipboardDocumentListIcon
    }
  ]
};

export default function _DocxToFlashcards() {
  return (
    <GeneratorLandingPage
      imageSection={imageSection}
      featureSection={featureSection}
      title="Image to Flashcards"
      description="Upload any image and generate instant flashcards. Grab images from your study materials or snap a picture of your notes.  Limbiks use advanced AI to help you learn it all."
    />
  );
}
